import { getErrorMessage } from "@/helpers/handleErrorResponse";
import { PostWidgetAnalysisConfigPayload } from "@/types/widget";
import { CustomError } from "@/utils/errors";

import axiosInstance from "../config";

export const postWidgetAnalysisConfig = async (
  body: PostWidgetAnalysisConfigPayload
) => {
  const { id, ...payload } = body;

  try {
    const { data } = await axiosInstance.post(
      `/v1/datasets/${id}/analytics`,
      payload
    );
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};

export const postWidgetDefaultConfig = async (id: string) => {
  try {
    const { data } = await axiosInstance.post(
      `/v1/datasets/${id}/default-widgets`
    );
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};
